(function(angular, _) {
    angular.module('GorillaBoy.services')
    .factory('FeedbackService',
        ['$timeout',
        '$q',
        '$log',
        '$http',
        'BaseHttpService',
        'EndpointService',
        'AppConstants',
        'localStorageService',
        'DocumentUtilities',
        'FeedbackLocalStorageService',
        'DocumentService',
        FeedbackService
    ]);

    function FeedbackService($timeout, $q, $log, $http, BaseHttpService, EndpointService, AppConstants, localStorageService,
        DocumentUtilities, FeedbackLocalStorageService, DocumentService) {
        var DOC_LEVEL = AppConstants.DOC_LEVEL;
        var DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION1 = "UnauthorizedResourceAccessException";
        var DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION2 = "DocumentLockedForCommentsException";
        var FEEDBACK_RESOLUTION_STATUS = AppConstants.FEEDBACK_RESOLUTION_STATUS;
        //AppConstant bindings
        var httpMethods = AppConstants.HttpMethods,
            SERVICE_ROOT = function(isNewAPI) {
                return isNewAPI ? EndpointService.endpoint(true) + 'documents/' : EndpointService.endpoint() + 'document/';
            };

        var service = new window.EventEmitter();
        var commentsToBeDeleted = [],
            annotationsToBeDeleted = [];

        var FeedbackTypes = AppConstants.FeedbackTypes;
        var feedbackSyncTaskTimeout = null;
        service.events = {
            AnnotationSynced : 'AnnotationSynced',
            CommentSynced : 'CommentSynced',
            AnnotationRetrying : 'AnnotationRetrying',
            CommentRetrying : 'CommentRetrying',
            AnnotationSyncFailed : 'AnnotationSyncFailed',
            CommentSyncFailed : 'CommentSyncFailed'
        };

        function isRecoverableError(response) {
            var err = response.data;
            if (err && err.Message && (err.Message.indexOf(DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION2) === 0 ||
                    err.Message.indexOf(DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION1) === 0)) {
                    return false;
            }
            if (response.status === AppConstants.HttpStatuses.CONFLICT ||
                response.status === AppConstants.HttpStatuses.BAD_REQUEST ||
                response.status === AppConstants.HttpStatuses.FORBIDDEN ||
                response.status === AppConstants.HttpStatuses.ENTITY_TOO_LARGE ||
                response.status === AppConstants.HttpStatuses.NOT_FOUND) {
                    return false;
            }
            return true;
        }

        function reMapProfilePhotoThumbnails(feedbackObj) {
            feedbackObj.Contributor.ProfilePhotoThumbnails = feedbackObj.Contributor.ProfilePhotoMetadata.ProfilePhotoThumbnails;
        }

        service.getUserToFeedbackCount = function(feedbackListMap) {
            var userToFeedbackCountMap = {};
            angular.forEach(feedbackListMap, function(feedbackSections, versionId) {
                if (!versionId || !feedbackSections || !feedbackSections.length) {
                    return;
                }
                angular.forEach(feedbackSections, function(section, title) {
                    // Only select cooments or annotations with its replies which are unresolved and not deleted
                    angular.forEach(section, function(obj) {
                        if (!obj.Contributor /*||
                            !obj.ResolutionInfo ||
                            obj.ResolutionInfo.ResolutionStatus === FEEDBACK_RESOLUTION_STATUS.RESOLVED */) { //Do not filter resolved comments for counting
                            return;
                        }
                        // If comment or annotation is deleted, we still count replies but not itself
                        if (!((obj.CommentStatus && obj.CommentStatus === FeedbackTypes.FEEDBACK_TYPE_DELETED) ||
                            (obj.AnnotationStatus && obj.AnnotationStatus === FeedbackTypes.FEEDBACK_TYPE_DELETED))) {
                            if (!userToFeedbackCountMap[obj.Contributor.Id]) {
                                userToFeedbackCountMap[obj.Contributor.Id] = 1;
                            } else {
                                userToFeedbackCountMap[obj.Contributor.Id]++;
                            }
                        }
                        if (obj.Replies) {
                            obj.Replies.forEach(function(replyObj) {
                                if (!replyObj.Contributor) {
                                    return;
                                }
                                if (!userToFeedbackCountMap[replyObj.Contributor.Id]) {
                                    userToFeedbackCountMap[replyObj.Contributor.Id] = 1;
                                } else {
                                    userToFeedbackCountMap[replyObj.Contributor.Id]++;
                                }
                            });
                        }
                    });
                });
            });
            return userToFeedbackCountMap;
        };

        function getFeedbackCount(feedbackList) {
            var numComments = 0;
            if (feedbackList) {
                feedbackList.forEach(function(feedbackSection) {
                    var feedbackSection2 = feedbackSection.filter(function(feedbackObj) {
                        return DocumentUtilities.isUnresolved(feedbackObj);
                    });
                    //Do not actually remove those Unresolved comments from here.
                    numComments += feedbackSection2.length;
                    feedbackSection.forEach(function(feedbackObj) {
                        if (feedbackObj.Replies) {
                            numComments += feedbackObj.Replies.length;
                        }
                    });
                });
            }
            return numComments;
        }

        function getFeedbackDraftCount(feedbackList) {
            var numDrafts = 0;
            if (feedbackList && feedbackList.length) {
                feedbackList.forEach(function(feedbackSection) {
                    //Only the annotations can be in draft mode, even though we mark Comments as Draft
                    //if the sync fails, they're not tracked so on the server side
                    if (feedbackSection.title !== AppConstants.DOC_LEVEL) {
                        feedbackSection.forEach(function(feedbackObj) {
                            if (feedbackObj.AnnotationStatus == FeedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                numDrafts++;
                            } else if (feedbackObj.Replies && feedbackObj.Replies.length) {
                                feedbackObj.Replies.forEach(function(replyObj) {
                                    if (replyObj.AnnotationStatus == FeedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                        numDrafts++;
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return numDrafts;
        }

        function feedbackSyncTaskTick() {
            var draftAnnotations = FeedbackLocalStorageService.readAnnotations(),
                firstDraftAnnotation,
                firstDraftComment,
                draftComments = FeedbackLocalStorageService.readComments(),
                firstPromise,
                i;

            //restore the intial value to the timeout variable. So it can be rescheduled
            feedbackSyncTaskTimeout = null;

            //If there's nothing to sync, just quit!
            if (draftAnnotations.length) {
                //make sure you cache the value in to local scoped var, the first element could change
                //when you access it later in the promise rejection handler
                firstDraftAnnotation = draftAnnotations[0];
                firstPromise = postAnnotation(firstDraftAnnotation).then(null, function(response) {
                    if (response && response.data && response.data.Message && response.data.Message.indexOf('The annotation that is being replied to has been deleted') !== -1) {
                        // ref: https://code.amazon.com/packages/AWSGorillaBoyBusinessLogic/blobs/mainline/--/src/com/amazon/aws/gorillaboy/bl/action/AnnotationAction.java#L206
                        FeedbackLocalStorageService.deleteAnnotationIfExists(firstDraftAnnotation.AnnotationId);
                    } else {
                        service.emit(service.events.AnnotationSyncFailed, {
                            DraftAnnotationId : firstDraftAnnotation.AnnotationId
                        });
                    }
                    service.startFeedbackSyncTask();
                    return $q.reject(response); //Make sure you reject it
                });
                draftAnnotations.slice(1).forEach(function(annotation) {
                    //Chain the promises such that the posting to the server happens in the right order
                    firstPromise = firstPromise.then(function() {
                        return postAnnotation(annotation);
                    }, function(response) {
                        service.emit(service.events.AnnotationSyncFailed, {
                            DraftAnnotationId : annotation.AnnotationId
                        });
                        return $q.reject(response); //Make sure you reject it
                    });
                });
            }
            if (draftComments.length) {
                //make sure you cache the value in to local scoped var, the first element could change
                //when you access it later in the promise rejection handler
                firstDraftComment = draftComments[0];
                firstPromise = postComment(firstDraftComment).then(null, function(response) {
                    if (response && response.data && response.data.Message && response.data.Message.indexOf('The comment that is being replied to has been deleted') !== -1) {
                        // ref: https://code.amazon.com/packages/AWSGorillaBoyBusinessLogic/blobs/mainline/--/src/com/amazon/aws/gorillaboy/bl/action/CommentAction.java#L330
                        FeedbackLocalStorageService.deleteCommentIfExists(firstDraftComment.CommentId);
                    } else {
                        service.emit(service.events.CommentSyncFailed, {
                            DraftCommentId : firstDraftComment.CommentId
                        });
                    }
                    service.startFeedbackSyncTask();
                    return $q.reject(response); //Make sure you reject it
                });
                draftComments.slice(1).forEach(function(comment) {
                    //Chain the promises such that the posting to the server happens in the right order
                    firstPromise = firstPromise.then(function() {
                        return postComment(comment);
                    }, function(response) {
                        service.emit(service.events.CommentSyncFailed, {
                            DraftCommentId : comment.CommentId
                        });
                        return $q.reject(response); //Make sure you reject it
                    });
                });
            }

            function postComment(comment) {
                service.emit(service.events.CommentRetrying, {
                    DraftCommentId : comment.CommentId
                });
                return service.postDocumentComment(comment).then(function(Comment) {
                    FeedbackLocalStorageService.deleteCommentIfExists(comment.CommentId);
                    service.emit(service.events.CommentSynced, {
                        DraftCommentId : comment.CommentId,
                        Comment : Comment
                    });
                }); //Do not implement failure callback w/o rejecting it. We want failure to propagate to the chain
            }

            function postAnnotation(annotation) {
                service.emit(service.events.AnnotationRetrying, {
                    DraftAnnotationId : annotation.AnnotationId
                });
                return service.postDocumentAnnotation(annotation).then(function(Annotation) {
                    FeedbackLocalStorageService.deleteAnnotationIfExists(annotation.AnnotationId);
                    service.emit(service.events.AnnotationSynced, {
                        DraftAnnotationId : annotation.AnnotationId,
                        Annotation : Annotation
                    });
                });
                //Do not implement failure callback w/o rejecting it. We want failure to propagate to the chain
            }
        }

        service.startFeedbackSyncTask = function() {
            if (feedbackSyncTaskTimeout) {
                $timeout.cancel(feedbackSyncTaskTimeout);
            }
            feedbackSyncTaskTimeout = $timeout(feedbackSyncTaskTick, 5000);
        };


        service.stopFeedbackSyncTask = function() {
            if (feedbackSyncTaskTimeout) {
                $timeout.cancel(feedbackSyncTaskTimeout);
            }
        };

        service.markCommentToBeDeleted = function(CommentId) {
            commentsToBeDeleted.push(CommentId);
        };

        service.markAnnotationToBeDeleted = function(AnnotationId) {
            annotationsToBeDeleted.push(AnnotationId);
        };

        service.deleteDocumentComment = function(documentId, documentVersion, commentId) {
            if (FeedbackLocalStorageService.deleteCommentIfExists(commentId)) {
                return $q.resolve(true);
            }
            var config = {
                url: SERVICE_ROOT() + documentId + '/version/' + documentVersion + '/comment/' + encodeURIComponent(commentId),
                method: httpMethods.DELETE
            };
            return BaseHttpService.callWithExpRetries(config);
        };

        service.updateCommentResolution  = function(documentId, documentVersionId, commentId, resolveIt) {
            var config = {
                url: SERVICE_ROOT() + documentId + '/version/' + documentVersionId + '/comment/' + commentId,
                method: httpMethods.PUT,
                data: {
                    ResolutionStatus: resolveIt ? 'RESOLVED' : 'UNRESOLVED'
                }
            };
            return BaseHttpService.callWithExpRetries(config);
        };

        service.updateAnnotationResolution  = function(documentId, documentVersionId, annotationId, resolveIt) {
            var config = {
                url: SERVICE_ROOT() + documentId + '/version/' + documentVersionId + '/annotation/' + annotationId,
                method: httpMethods.PUT,
                data: {
                    ResolutionStatus: resolveIt ? 'RESOLVED' : 'UNRESOLVED'
                }
            };
            return BaseHttpService.callWithExpRetries(config);
        };

        service.deleteDocumentAnnotation = function(documentId, documentVersion, annotationId) {
            if (FeedbackLocalStorageService.deleteAnnotationIfExists(annotationId)) {
                return $q.resolve(true);
            }

            var config = {
                url: SERVICE_ROOT() + documentId + '/version/' + documentVersion + '/annotation/' + annotationId,
                method: httpMethods.DELETE,
                data: {
                    DocumentId: documentId,
                    VersionId: documentVersion,
                    AnnotationId: annotationId
                }
            };
            return BaseHttpService.callWithExpRetries(config);
        };

        service.computeDocVersionCommentsAndPendingFeedback = function(feedbackListMap) {
            var documentVersionCommentsMap = {},
                pendingFeedbackCountForAllVersions = 0;
            Object.keys(feedbackListMap).forEach(function(versionId) {
                if (!versionId) {
                    return;
                }
                //The following documentVersionCommentsMap is used to check if we have to display the Version/page headers in the Feedback panel
                //So it basically keeps track of how many feedbacks (comments or annotations, does not matter) a particular version has
                documentVersionCommentsMap[versionId] = getFeedbackCount(feedbackListMap[versionId]);
                pendingFeedbackCountForAllVersions += getFeedbackDraftCount(feedbackListMap[versionId]);
            });
            return {
                documentVersionCommentsMap : documentVersionCommentsMap,
                pendingFeedbackCountForAllVersions : pendingFeedbackCountForAllVersions
            };
        };

        service.postDocumentComment = function(commentData) {
            if (!commentData || !commentData.DocumentId || !commentData.VersionId || !commentData.Text) {
                return $q.reject('Invalid commentData object passed as param');
            }
            if (commentData.ParentId && DocumentService.isGeneratedDraftFeedbackId(commentData.ParentId)) {
                return $q.reject('Invalid ParentId starting with draft-feedback-')
            }
            var notifyCollaborators = commentData.NotifyCollaborators;
            var commentDataLocal = {
                Text : commentData.Text,
                Visibility: commentData.Visibility ? commentData.Visibility : FEEDBACK_VISIBILITY.PUBLIC,
                DocumentId : commentData.DocumentId,
                VersionId : commentData.VersionId,
                ParentId : commentData.ParentId,
                Status: AppConstants.FeedbackTypes.FEEDBACK_TYPE_PUBLISHED,
                NotifyCollaborators: notifyCollaborators,
                //NotificationScope is not used on the backend
                NotificationScope: !!notifyCollaborators ? 'CONTRIBUTORS' : 'OWNER'
            };
            var config = {
                url: SERVICE_ROOT() + commentData.DocumentId + '/version/' + commentData.VersionId + '/comment',
                method: httpMethods.POST,
                data: commentDataLocal
            };
            return $q(function(resolve, reject) {
                BaseHttpService.callWithExpRetries(config).then(function(response) {
                    var data = response.data,
                        Comment = data;
                    resolve(Comment);
                    service.emit(service.events.CommentSynced, {
                        DraftCommentId : commentData.CommentId,
                        Comment : Comment
                    });
                }, function(response) {
                    var err = response.data;
                    if(isRecoverableError(response)) {
                        FeedbackLocalStorageService.writeNewComments([commentData]);
                        service.startFeedbackSyncTask();
                    }
                    reject(response);
                });
            });
        };

        service.updateDocumentAnnotation = function(annotation) {
            var config = {
                url: SERVICE_ROOT() + annotation.DocumentId + '/version/' + annotation.VersionId + '/annotation/' +
                    encodeURIComponent(annotation.AnnotationId),
                method: httpMethods.PUT,
                data: {
                    DocumentId: annotation.DocumentId,
                    Visibility: annotation.Visibility ? annotation.Visibility : FEEDBACK_VISIBILITY.PUBLIC,
                    VersionId: annotation.VersionId,
                    Text: annotation.Text
                }
            };
            return $http(EndpointService.tokenize(config));
        };

        /**
         * This method will post the document annotation to the AWSGorillaBoyService. Also note that this service takes a single argument with all the
         * necessary information. The reason for that is, we can push that argument into the local storage and use it for retries.
         */
        service.postDocumentAnnotation = function(annotation) {
            if (annotation && annotation.ParentId && DocumentService.isGeneratedDraftFeedbackId(annotation.ParentId)) {
                return $q.reject('Invalid ParentId starting with draft-feedback-');
            }
            var config = {
                url: SERVICE_ROOT() + annotation.DocumentId + '/version/' + annotation.VersionId + '/annotation',
                method: httpMethods.POST,
                data: {
                    DocumentId: annotation.DocumentId,
                    VersionId: annotation.VersionId,
                    ParentId : annotation.ParentId ? annotation.ParentId : undefined,
                    Text: annotation.Text,
                    Visibility: annotation.Visibility ? annotation.Visibility : FEEDBACK_VISIBILITY.PUBLIC,
                    Regions: annotation.Regions,
                    AnnotationType: annotation.AnnotationType,
                    StartPageNumber: annotation.StartPageNumber
                }
            };
            return $q(function(resolve, reject) {
                BaseHttpService.callWithExpRetries(config).then(function(response) {
                    var data = response.data,
                        Annotation = data.Annotation;
                    resolve(Annotation);
                    service.emit(service.events.AnnotationSynced, {
                        DraftAnnotationId : annotation.AnnotationId,
                        Annotation : Annotation
                    });
                }, function(response) {
                    var err = response.data;
                    if(isRecoverableError(response)) {
                        //TODO Do not retry for all scenarios, only whitelisted status should trigger retries.
                        FeedbackLocalStorageService.writeNewAnnotations([annotation]);
                        service.startFeedbackSyncTask();
                    }
                    reject(response);
                });
            });
        };

        service.disableFeedbackForDocument = function(documentId, isLocked) {
            var config = {
                method: httpMethods.PATCH,
                url : SERVICE_ROOT(true) + documentId,
                data: {
                    DocumentId: documentId,
                    //When sending data to backend the CommentsLocked field should be capital case
                    CommentsLocked : isLocked ? "TRUE" : "FALSE"
                }
            };
            return BaseHttpService.callWithExpRetries(config);
        };

        /**
         * For a given documentId and a set of version IDs, it'll publish all draft annotations
         */
        service.publishDraftAnnotationsForVersions = function(documentId, versionIdsArray, notifyContributors) {
            var config = {
                method: httpMethods.PUT,
                data: {
                    DocumentId: documentId,
                    Status: 'PUBLISHED',
                    NotificationScope: !!notifyContributors ? 'CONTRIBUTORS' : 'OWNER'
                }
            };
            var promises = [];
            versionIdsArray.forEach(function(versionId) {
                config = angular.copy(config);
                config.url = SERVICE_ROOT() + documentId + '/version/' + versionId + '/annotation';
                config.data.VersionId = versionId;
                promises.push(BaseHttpService.callWithExpRetries(config));
            });
            return $q.all(promises);
        };

        service.getFeedbackMapForAllVersions = function(documentId, versionsList) {
            var deferredObj = $q.defer(),
                commentsMap = {},
                annotationsMap = {};

            var promises = [];
            versionsList.forEach(function(versionId) {
                promises.push(service.getDocumentCommentsExhaustively(documentId, versionId).then(function(CommentMetadataList) {
                    if (!commentsMap[versionId]) {
                        commentsMap[versionId] = [];
                    }
                    commentsMap[versionId] = CommentMetadataList;
                }));
                promises.push(service.getDocumentAnnotationsExhaustively(documentId, versionId).then(function(AnnotationList) {
                    if (!annotationsMap[versionId]) {
                        annotationsMap[versionId] = [];
                    }
                    annotationsMap[versionId] = AnnotationList;
                }));
            });

            $q.all(promises).then(function() {
                deferredObj.resolve(toFeedbackListMap());
            }, function() {
                deferredObj.reject(toFeedbackListMap());
            });
            return deferredObj.promise;

            function toFeedbackListMap() {
                var feedbackListMap = {};
                versionsList.forEach(function(versionId) {
                    var feedbackSection;
                    var feedbackList = feedbackListMap[versionId] = [];
                    if (commentsMap[versionId]) {
                        feedbackSection = commentsMap[versionId];
                        feedbackSection.title = AppConstants.DOC_LEVEL;
                        feedbackSection.marker = 0;
                        feedbackList.push(feedbackSection);
                    }
                    if (annotationsMap[versionId]) {
                        var pageVsAnnotationList = _.groupBy(annotationsMap[versionId], function(annotation) {
                            return annotation.StartPageNumber;
                        });
                        angular.forEach(pageVsAnnotationList, function(annotationList, pageIndex) {
                            var pageNumber = ((+pageIndex) + 1);
                            feedbackSection = annotationList;
                            feedbackSection.title = 'Page ' + pageNumber;
                            feedbackSection.marker = pageNumber;
                            feedbackList.push(feedbackSection);
                        });
                    }
                });
                return feedbackListMap;
            }
        };

        service.getDocumentCommentsExhaustively = function(documentId, versionId) {
            var deferred = $q.defer(),
                comments = [];

            makeTheCall({});
            return deferred.promise;

            function successFn(response) {
                var data = response.data;
                if (!data || !data.CommentMetadataList) {
                    deferred.reject(comments);
                    return;
                }
                data.CommentMetadataList.forEach(function(comment) {
                    comment.VersionId = versionId;
                    comment.DocumentId = documentId;
                    reMapProfilePhotoThumbnails(comment);
                });
                comments = comments.concat(data.CommentMetadataList);
                if (data.Marker !== undefined && data.Marker) {
                    makeTheCall({marker : data.Marker});
                } else {
                    comments = service.__groupFeedbackByThreadId(comments);
                    comments = service.__removeSoftDeletedFeedback(comments);
                    service.__sortFeedbackReplies(comments);
                    comments.sort(function(a, b) {
                        return a.Created.localeCompare(b.Created);
                    });
                    deferred.resolve(comments);
                }
            }

            function errorFn(response) {
                deferred.reject(comments);
            }

            function makeTheCall(params) {
                service.getDocumentComments(documentId, versionId, params).then(successFn, errorFn);
            }
        };

        service.getDocumentAnnotationsExhaustively = function(documentId, versionId) {
            var deferred = $q.defer(),
                annotations = [];

            makeTheCall({});
            return deferred.promise;

            function successFn(response) {
                var data = response.data;
                if (!data || !data.AnnotationList) {
                    deferred.reject(annotations);
                    return;
                }
                data.AnnotationList.forEach(function(val) {
                    val.VersionId = versionId;
                    val.DocumentId = documentId;
                    reMapProfilePhotoThumbnails(val);
                });
                annotations = annotations.concat(data.AnnotationList);
                if (data.Marker !== undefined && data.Marker) {
                    makeTheCall({marker: data.Marker});
                } else {
                    annotations = service.__groupFeedbackByThreadId(annotations);
                    annotations = service.__removeSoftDeletedFeedback(annotations);
                    deferred.resolve(annotations);
                }
            }

            function errorFn(response) {
                deferred.reject(annotations);
            }

            function makeTheCall(params) {
                service.getDocumentAnnotations(documentId, versionId, params).then(successFn, errorFn);
            }
        };

        service.__sortFeedbackReplies = function(feedbackObjs) {
            feedbackObjs.forEach(function(feedbackObj) {
                if (feedbackObj.Replies) {
                    feedbackObj.Replies.sort(DocumentUtilities.feedbackRepliesComparator);
                }
            });
        };

        service.__removeSoftDeletedFeedback = function(feedbackObjs) {
            return feedbackObjs.filter(function(feedbackObj) {
                var isAnnotation = !!feedbackObj.AnnotationId,
                    isComment = !!feedbackObj.CommentId;

                if (feedbackObj.Replies && feedbackObj.Replies.length) {
                    //Clean up the replies list also
                    feedbackObj.Replies = feedbackObj.Replies.filter(function(replyAnnotation) {
                        return (isAnnotation && replyAnnotation.AnnotationStatus !== 'DELETED') || (isComment && replyAnnotation.CommentStatus !== 'DELETED');
                    });
                }
                if ((isAnnotation && feedbackObj.AnnotationStatus !== 'DELETED') || (isComment && feedbackObj.CommentStatus !== 'DELETED')) {
                    return true;
                }
                return feedbackObj.Replies && feedbackObj.Replies.length;
            });
        };

        /**
         * The below function is attached to $scope only for testability purposes, it's not intended to be used
         * from the templates. So it's essentially private function
         */
        service.__groupFeedbackByThreadId = function(feedbackObjArray) {
            var result = [],
                feedbackIdToObjMap = {},
                parentFeedbackIndexedByThreadId = {},
                repliesGroupedByThreadId = {};

            angular.forEach(feedbackObjArray, function(item) {
                var feedbackId = DocumentUtilities.isComment(item) ? item.CommentId : item.AnnotationId;
                var text = DocumentUtilities.parseTextAndEmbedMarkdownForEmails(item.Text);
                item.MarkupText = remarkableMd.render(text);
                feedbackIdToObjMap[feedbackId] = item;
                if (item.ParentId) {
                    if (repliesGroupedByThreadId[item.ThreadId]) {
                        repliesGroupedByThreadId[item.ThreadId].push(item);
                    } else {
                        repliesGroupedByThreadId[item.ThreadId] = [item];
                    }
                } else {
                    //Just in case the top level annotation/comment doesn't have a ThreadId, use its
                    //feedbackId (which is CommentId or AnnotationId) as the ThreadId
                    if (!item.ThreadId) {
                        item.ThreadId = feedbackId;
                    }
                    parentFeedbackIndexedByThreadId[item.ThreadId] = item;
                    result.push(item);
                }
            });

            //Create back links
            angular.forEach(feedbackIdToObjMap, function(feedbackObj, feedbackId) {
                if (feedbackObj.ParentId) {
                    feedbackObj.ParentFeedback = feedbackIdToObjMap[feedbackObj.ParentId];
                }
            });

            //At the end of the above forEach iteration, repliesGroupedByThreadId will contain arrays of all child replies grouped by ParentId
            //parentFeedbackIndexedByThreadId will contain all parent feedback objects

            angular.forEach(repliesGroupedByThreadId, function(childFeedbackArray, threadId) {
                var parentFeedback = parentFeedbackIndexedByThreadId[threadId];
                if (!parentFeedback) {
                    return;
                }
                parentFeedback.Replies = childFeedbackArray;
            });
            return result;
        };

        service.getDocumentComments = function(documentId, documentVersion, params) {
            var config = {
                url: EndpointService.endpoint() + 'document/' + documentId + '/version/' +
                    documentVersion + '/comment?includeReplies=true',
                method: httpMethods.GET,
                params: params
            };
            return BaseHttpService.callWithExpRetries(config);
        };

        //canceller is used for cancel the request if the request is not finished when the document has changed
        service.getDocumentAnnotations = function(documentId, documentVersion, params) {
            var config = {
                url: EndpointService.endpoint() + 'document/' + documentId + '/version/' +
                    documentVersion + '/annotation?includeReplies=true',
                method: httpMethods.GET,
                params: params
            };
            return BaseHttpService.callWithExpRetries(config);
        };

        service.getArrowTopPosition = function(annotationTileBCR) {
            // 8px is the distance between the top of the tile to the middle of the name of annotation auther
            return Math.round(annotationTileBCR.top + 8);
        };

        return service;
    }

}(angular, _));
